var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({
    height: _vm.height+'px',
    // overflow: 'hidden'
  })},[_c('div',{staticStyle:{"height":"100%"}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }